import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { IGetState, TBoardId } from '../../../../../types/types';
import { fetchHandler } from '../../../../../util/fetchHandler';
import { getRestHeadersGet } from '../../../../../rest/helpers/getRestHeadersHelper';
import { IMSRestoreUsers } from '../store/types';

export const getMSUsersForRestoredBoard = (
    boardId: TBoardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetchHandler<IMSRestoreUsers[]>(
            `/rest/dashboards/${boardId}/backupSharedUsers`,
            { ...getRestHeadersGet(), }
        );
    };
    return action;
};
